import React from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { normalizeFieldValue } from '../../../_helper/regexHandler';

export const CustomerNumberFilter = ({
    value,
    onChange,
    md = 3,
    sm = 6,
    label = 'Vergi / Kimlik Numarası',
    placeholder = 'Müşteri vergi veya kimlik no (en az 3 karakter)',
    minLength = 3,
    showMinLengthHint = true
}) => {
    return (
    <Col md={md} sm={sm}>
        <FormGroup>
            <Label>{label}</Label>
            <Input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </FormGroup>
    </Col>
    );
};

export const CustomerNameFilter = ({
    value,
    onChange,
    md = 3,
    sm = 6,
    label = 'Müşteri İsmi / Şirket İsmi',
    placeholder = 'Müşteri ismi veya şirket ismi (en az 2 karakter)',
    minLength = 2,
    showMinLengthHint = true
}) => {
    return (
    <Col md={md} sm={sm}>
        <FormGroup>
            <Label>{label}</Label>
            <Input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </FormGroup>
    </Col>
    );
};

export const PlateFilter = ({
    value,
    onChange,
    md = 3,
    sm = 6,
    label = 'Plaka',
    placeholder = 'Plaka (en az 2 karakter)',
    minLength = 2,
    showMinLengthHint = true
}) => {
    const handlePlateChange = (event) => {
        const nextValue = normalizeFieldValue('plateSearch', event.target.value);
        if (typeof onChange === 'function') {
            onChange({
                ...event,
                target: {
                    ...event.target,
                    value: nextValue
                }
            });
        }
    };

    return (
    <Col md={md} sm={sm}>
        <FormGroup>
            <Label>{label}</Label>
            <Input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={handlePlateChange}
            />
        </FormGroup>
    </Col>
    );
};

export const AccidentDateFilter = ({
    value,
    onChange,
    md = 3,
    sm = 6,
    label = 'Kaza Tarihi'
}) => (
    <Col md={md} sm={sm}>
        <FormGroup>
            <Label>{label}</Label>
            <Input
                type="date"
                value={value}
                onChange={onChange}
            />
        </FormGroup>
    </Col>
);
